import Header from "components/Header";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  Grid,
  Button,
  TextField,
} from "@mui/material";
import BG from "../../assets/images/BG.png";
import { Check, Telegram } from "@mui/icons-material";
import Contact from "components/Contact";
import { useEffect, useState } from "react";
import { GradientCircularProgress } from "components/Loading";
import LocationMaps from "components/LocationMaps";

const PACKAGES = [
  {
    name: "ราคา",
    month_package: "1000 THB ต่อเดือน",
    license_package: "10000 THB",
  },
  {
    name: "ราคารวมฟังก์ชันคิดค่าจอดรถ",
    month_package: "2000 THB ต่อเดือน",
    license_package: "20000 THB",
  },
  {
    name: " เครืองบันทึกผู้มาติดต่อ",
    month_package: "1 เครื่อง",
    license_package: "1 เครื่อง",
  },
  {
    name: "Internet SIM",
    month_package: "1 SIM",
    license_package: "1 SIM",
  },
  {
    name: "การรับประกันเครื่องบันทึกผู้มาติดต่อ",
    month_package: "ตลอดระยะเวลาเช่า",
    license_package: "1 ปี",
  },
  {
    name: "โปรแกรมบันทึกผู้มาติดต่อ",
    month_package: <Check />,
    license_package: <Check />,
  },
  {
    name: "ระบบบริหารจัดการผ่านเว็บเบราว์เซอร์",
    month_package: " 1 Admin",
    license_package: "1 Admin",
  },
  {
    name: "จำนวน User สำหรับ Login",
    month_package: "3 User",
    license_package: "3 User",
  },
  {
    name: "การเก็บข้อมูล",
    month_package: "เก็บบน Cloud Server (6 เดือน)",
    license_package:
      "เก็บบน Cloud Server (6 ปี) ค่าใช้งานระบบ Cloud 10% ต่อปี (เริ่มจากปีที่ 2)",
  },
  {
    name: "Software Update",
    month_package: "ได้ใช้งาน Software เวอร์ชั่นล่าสุด",
    license_package: "ได้ใช้งาน Software เวอร์ชั่นล่าสุด",
  },
  {
    name: "ค่าติดตั้ง",
    month_package: "-",
    license_package: "-",
  },
];

function PackagesContact() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 500);
  }, []);

  if (isLoading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <GradientCircularProgress />
      </Box>
    );
  }

  return (
    <>
      <Header />
      <Box
        sx={{
          position: "relative",
          backgroundImage: `url(${BG})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          height: "300px",
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          mt: "76px",
        }}
      >
        <Typography variant="h3">Contact</Typography>
        <Typography variant="h5">สนใจสมัครร้านค้า</Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          mt: 2,
          padding: 2,
          justifyContent: "center",
          gap: 2,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            padding: 2,
            gap: 5,
            alignItems: "center",
          }}
        >
          <Typography
            variant="h4"
            sx={{
              marginLeft: "10%",
              alignSelf: "flex-start",
            }}
          >
            Pricing
          </Typography>
          <Table
            sx={{
              width: "80%",
              margin: "auto",
              "& .MuiTableCell-root": {
                textAlign: "center",
                verticalAlign: "middle",
              },
              "& .MuiTableCell-root:nth-of-type(1)": {
                textAlign: "left",
              },
            }}
          >
            <TableHead
              sx={{
                backgroundImage: "linear-gradient(to left, #4cb8ba, #7bd867)",
                "& .MuiTableCell-root": { color: "white", fontSize: "20px" },
              }}
            >
              <TableRow>
                <TableCell></TableCell>
                <TableCell>แบบรายเดือน</TableCell>
                <TableCell>แบบ License</TableCell>
              </TableRow>
            </TableHead>
            <TableBody
              sx={{
                "& .MuiTableCell-root": {
                  fontSize: "22px",
                  border: "2px solid #ccc",
                },
                "& .MuiTableRow-root:nth-of-type(1)": {
                  "& .MuiTableCell-root": {
                    borderTop: "0px",
                  },
                },
              }}
            >
              {PACKAGES.map((item, index) => (
                <TableRow key={index}>
                  <TableCell>{item.name}</TableCell>
                  <TableCell>{item.month_package}</TableCell>
                  <TableCell>{item.license_package}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>
        <Typography variant="h4" sx={{ color: "blue", mt: 2 }}>
          ติดต่อเรา
        </Typography>
        <Typography variant="h5">
          ติดต่อ : บริษัท อี-โพส เซอร์วิส จำกัด
          <br /> ที่อยู่ : 1041/7, ซอยสีลม 21 ถนน สีลม แขวง สีลม เขตบางรัก
          กรุงเทพมหานคร 10500
          <br />
          อีเมล : epossenicegroup@eposservice.com (อีเมลี่ใช้สำหรับการติดต่อ)
          <br />
          เวลาทำการ : วันจันทร์ - วันศุกร์ เวลา 8:30 - 17:30 น.
        </Typography>
        <Box
          sx={{ display: "flex", justifyContent: "center", mt: 2, mb: 2, p: 2 }}
        >
          <Grid container spacing={5}>
            <Grid item xs={4}>
              <Typography
                sx={{
                  fontSize: "26px",
                  fontWeight: "Semibold",
                }}
              >
                แผนที่ GPS
              </Typography>
              <LocationMaps />
            </Grid>
            <Grid item xs={8}>
              <Typography
                sx={{
                  fontSize: "26px",
                  fontWeight: "Semibold",
                }}
              >
                ส่งข้อความถึงเรา
              </Typography>
              <Grid container spacing={1} sx={{ mt: 1 }}>
                <Grid item xs={6}>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 5,
                      maxWidth: "500px",
                    }}
                  >
                    <TextField label="ชื่อ" variant="outlined" />
                    <TextField label="อีเมล" variant="outlined" />
                    <TextField label="เบอร์โทรศัพท์" variant="outlined" />
                    <TextField label="บริษัท" variant="outlined" />
                  </Box>
                </Grid>
                <Grid item xs={6}>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 5,
                      maxWidth: "500px",
                    }}
                  >
                    <TextField
                      label="ข้อความ"
                      variant="outlined"
                      rows={10}
                      multiline
                    />
                    <Button
                      className="button-two-tone"
                      variant="contained"
                      sx={{
                        width: "100%",
                      }}
                      endIcon={<Telegram />}
                    >
                      ส่งข้อความ
                    </Button>
                  </Box>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Box>
      <Contact />
    </>
  );
}

export default PackagesContact;
